import { styled } from '@linaria/react';
import theme from '@clad-ui/theme';
const {
  space
} = theme;
const Modal = /*#__PURE__*/styled('div')({
  name: "Modal",
  class: "m12aktmt",
  propsAsIs: false
});
const StyledPopup = /*#__PURE__*/styled('div')({
  name: "StyledPopup",
  class: "sn89hzc",
  propsAsIs: false
});
const StyledTitle = /*#__PURE__*/styled('h5')({
  name: "StyledTitle",
  class: "s1ibure9",
  propsAsIs: false
});
const StyledHeader = /*#__PURE__*/styled('div')({
  name: "StyledHeader",
  class: "s1x0wzn0",
  propsAsIs: false
});
const _exp48 = /*#__PURE__*/() => ({
  haveClose
}) => haveClose ? space.xs : space.md;
const StyledWrapper = /*#__PURE__*/styled('div')({
  name: "StyledWrapper",
  class: "semvboi",
  propsAsIs: false,
  vars: {
    "semvboi-0": [_exp48()]
  }
});
const _exp52 = /*#__PURE__*/() => ({
  btnGroupDirection
}) => btnGroupDirection.flexDirection;
const _exp54 = /*#__PURE__*/() => ({
  position
}) => position.justifyContent;
const StyledButtonGroup = /*#__PURE__*/styled('div')({
  name: "StyledButtonGroup",
  class: "s19vd2kh",
  propsAsIs: false,
  vars: {
    "s19vd2kh-0": [_exp52()],
    "s19vd2kh-1": [_exp54()]
  }
});
const buttonClass = "b96a670";
const CloseButtonClass = "c1dpllo9";
const ChildrenWrapper = /*#__PURE__*/styled('div')({
  name: "ChildrenWrapper",
  class: "cm8u7e7",
  propsAsIs: false
});
const StyledImage = /*#__PURE__*/styled('img')({
  name: "StyledImage",
  class: "s79bu9k",
  propsAsIs: false
});

// We need to use !important to override the body scroll
const preventBodyScrollClass = "p1sgj6zi";

// To visible children inside children wrapper in overflow-y case
const showChildrenOverflowClass = "swj39vp";
const Backdrop = /*#__PURE__*/styled('div')({
  name: "Backdrop",
  class: "bcdvy6c",
  propsAsIs: false
});
export { Modal, StyledPopup, CloseButtonClass, StyledHeader, StyledWrapper, ChildrenWrapper, StyledButtonGroup, StyledImage, Backdrop, buttonClass, showChildrenOverflowClass, preventBodyScrollClass, StyledTitle };

require("./Popup.styles.linaria.module.css");